// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FiltersShowMore: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 11,
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 11 11" width={size} height={size}>
        <path
            fill="currentColor"
            d="M5.76 1.01a.386.386 0 0 0-.385-.385.386.386 0 0 0-.385.385v4.23H.76a.386.386 0 0 0-.385.385c0 .212.173.385.385.385h4.23v4.23a.386.386 0 0 0 .77 0V6.01h4.23a.386.386 0 0 0 .385-.385.386.386 0 0 0-.385-.385H5.76z"
        />
    </svg>
);

export default React.memo(FiltersShowMore);
